const Direction = {
  TOP: 'top',
  RIGHT: 'right',
  LEFT: 'left',
  BOTTOM: 'bottom',
  CENTER: 'center',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  TOP_END: 'top-end',
}

export default Object.freeze(Direction)
